import { InjectionToken, NgModule, APP_INITIALIZER } from '@angular/core';
import { IPublicClientApplication, PublicClientApplication, 
    LogLevel, 
    BrowserCacheLocation} from '@azure/msal-browser';
import { MsalGuard, MsalInterceptor, MsalBroadcastService,
     MsalInterceptorConfiguration, MsalModule, MsalService,
      MSAL_GUARD_CONFIG, MSAL_INSTANCE, MSAL_INTERCEPTOR_CONFIG, MSAL_BROADCAST_CONFIG,
      MsalGuardConfiguration } from '@azure/msal-angular';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ConfigService } from './config.service';
import { b2cPolicies, CommonAdPolicies } from './auth-config.interface';
import * as AdDataInfo from '../assets/appsettings.json';
import { AdDataModel } from './msal-module/azure-ad.interface';
import * as constants from '../app/shared/globalcontants';
import * as MasterData from '../assets/json/azure-config.json';
const MsalDefaultData = AdDataInfo['default'];
const AUTH_CONFIG_URL_TOKEN = new InjectionToken<string>('AUTH_CONFIG_URL');
export function initializerFactory(env: ConfigService, configUrl: string): any {
    const promise = env.init(configUrl).then((value) => {
        console.log(value)
    });
    return () => promise;
}

const isIE = window.navigator.userAgent.indexOf("MSIE ") > -1 || window.navigator.userAgent.indexOf("Trident/") > -1; // Remove this line to use Angular Universal
export function loggerCallback(logLevel: LogLevel, message: string) {
  console.log(message);
}

function constractAdAuthority( AzureAdType: string, adModelObject: AdDataModel, MasterData: any ): string {
    try{
      let adAuthority: string = MasterData.authority
       if ( AzureAdType ){
            if( AzureAdType === constants.AzureAdType.LDAP ){
              adAuthority = MasterData.authority;
            } else if( AzureAdType === constants.AzureAdType.CUSTOMERB2C || AzureAdType === constants.AzureAdType.PRODUCTB2C ){
              const azureAdB2CUserflow :String = adModelObject.AzureAdB2CUserflow ? adModelObject.AzureAdB2CUserflow : adModelObject['AzureADB2CUserflow'];
              const azureAdB2CTenant :String = adModelObject.AzureAdB2CTenant ? adModelObject.AzureAdB2CTenant : adModelObject['AzureADB2CTenant'];
              adAuthority = `${adModelObject.AzureADB2CAuthority}/` + `${azureAdB2CTenant}/` + `${azureAdB2CUserflow}`;
            } else if( AzureAdType === constants.AzureAdType.AZUREADSAML){
              // adAuthority = adModelObject.AzureADB2CAuthority+`/${adModelObject.TenantId}/federationmetadata/2007-06/federationmetadata.xml?appid=`+`${adModelObject.ClientId}`;
              adAuthority = adModelObject.AzureADB2CAuthority+`/${adModelObject.TenantId}`;
            } else if( AzureAdType === constants.AzureAdType.AZUREOPENID ){
              adAuthority = adModelObject.AzureADB2CAuthority+`/${adModelObject.TenantId}`;
            }
            return adAuthority;
       }
  
    } catch(error){
  
      console.error(error);
  
    }
  
  }

export function MSALInstanceFactory(config: ConfigService): IPublicClientApplication {
  let msalConfig: any = sessionStorage.getItem('azureadconfig');
  if (msalConfig) {
    msalConfig = JSON.parse(msalConfig);
  } else {
    msalConfig = GetMSALConfig(config);
  }
  return new PublicClientApplication(msalConfig);
}

export function GetMSALConfig(config: ConfigService) {
  const AdInfo = config.getSettings('AdData');
  return {
    auth: {
        clientId: ( AdInfo ) ? AdInfo.ClientId : '',
        // authority:  ( AdInfo && AdInfo.AzureAdType ) ? `${AdInfo.AzureADB2CAuthority}/` + `${AdInfo.AzureADB2CTenant}/` + `${AdInfo.AzureADB2CUserflow}` : CommonAdPolicies.authorities.signUpSignIn.authority,
        authority:  ( AdInfo && AdInfo.AzureAdType ) ? constractAdAuthority(AdInfo.AzureAdType, AdInfo, MasterData)  : CommonAdPolicies.authorities.signUpSignIn.authority,
        knownAuthorities: ( AdInfo?.AzureADB2CAuthority ) ? [AdInfo.AzureADB2CAuthority] : CommonAdPolicies.authorityDomain,
        redirectUri: CommonAdPolicies.redirectUri, 
        navigateToLoginRequestUrl: true,
    },
    cache: {
        cacheLocation: BrowserCacheLocation.LocalStorage
    },
    system: {
        allowNativeBroker: false, // Disables WAM Broker
        loggerOptions: {
           loggerCallback: (logLevel, message, containsPii) => {
               console.log(message);
            },
            logLevel: LogLevel.Verbose,
            piiLoggingEnabled: false,
        }
    }
  }
}
export function MSALInterceptorConfigFactory(config: ConfigService): MsalInterceptorConfiguration {
    const protectedResourceMap = new Map<string, Array<string>>(MsalDefaultData.interceptor.protectedResourceMap)
    return {
      interactionType: MsalDefaultData.interceptor.interactionType,
      protectedResourceMap
    };
  }
  
export function MSALGuardConfigFactory(config: ConfigService): MsalGuardConfiguration {
    const AdInfo = config.getSettings('AdData');
    return { 
      interactionType: MsalDefaultData.guard.interactionType,
      authRequest: {
        "scopes": ( AdInfo && AdInfo.AzureAdType ) ? ['openid'] : ['openid', 'profile', 'User.Read', 'offline_access']
      },
      loginFailedRoute: MsalDefaultData.guard.loginFailedRoute
    };
}

@NgModule({
    providers: [],
    imports: [MsalModule]
})
export class MsalConfigDynamicModule {
    static forRoot(configFile: string) {
        return {
            ngModule: MsalConfigDynamicModule,
            providers: [
                ConfigService,
                { provide: AUTH_CONFIG_URL_TOKEN, useValue: configFile },
                { provide: APP_INITIALIZER, useFactory: initializerFactory,
                     deps: [ConfigService, AUTH_CONFIG_URL_TOKEN], multi: true },
                {
                    provide: MSAL_INSTANCE,
                    useFactory: MSALInstanceFactory,
                    deps: [ConfigService]
                },
                {
                    provide: MSAL_GUARD_CONFIG,
                    useFactory: MSALGuardConfigFactory,
                    deps: [ConfigService]
                },
                {
                    provide: MSAL_INTERCEPTOR_CONFIG,
                    useFactory: MSALInterceptorConfigFactory,
                    deps: [ConfigService]
                },
                {
                    // APP_INITIALIZER's handleRedirectObservable() fires msal events before any
                    // component subscribes; msalSubject$ is a plain Subject by default and drops
                    // events emitted before subscription, so replay them for late subscribers.
                    provide: MSAL_BROADCAST_CONFIG,
                    useValue: { eventsToReplay: 20 }
                },
                MsalService,
                MsalGuard,
                MsalBroadcastService,
                // {
                //     provide: HTTP_INTERCEPTORS,
                //     useClass: MsalInterceptor,
                //     multi: true
                // }
            ]
        };
    }
}
